import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Spinner from "../../Components/Spinner/Spinner";
import baseUrl from "../../baseUrl";

const AddBlog = () => {
  const token = JSON.parse(localStorage.getItem("admin-token"));
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState("");

  const [loading, setLoading] = useState(false);

  const handleBlog = (e) => {
    e.preventDefault();

    setLoading(true);
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", image);

    axios
      .post(`${baseUrl}/admin/add-blog`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.success == true) {
          toast.success(res.data.message);
          navigate("/admin/all-blogs");
          setTitle("");
          setDescription("");
          setImage("");
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <>
      {loading && <Spinner />}
      <nav
        className="container w-auto text-black font-bold mx-5 my-4"
        aria-label="Breadcrumb"
      >
        <h3 className="text-gray-700 text-3xl font-medium">Add Blog</h3>
      </nav>

      <div className="py-2">
        <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
          <div className="bg-white overflow-hidden shadow-sm sm:rounded-lg">
            <div className="p-6 bg-white border-b border-gray-200">
              <h3 className="pt-4 text-2xl text-center">Add Blog</h3>
              <form onSubmit={handleBlog}>
                <div className="mb-4">
                  <label className="text-xl text-gray-600">
                    Title <span className="text-red-500">*</span>
                  </label>

                  <input
                    type="text"
                    className="border-2 border-gray-300 p-2 w-full"
                    name="title"
                    id="title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-8">
                  <label className="text-xl text-gray-600">
                    Image <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="file"
                    className="border-2 border-gray-300 p-2 w-full"
                    name="image"
                    accept="image/*"
                    onChange={(e) => setImage(e.target.files[0])}
                    required
                  />
                </div>
                <div className="mb-8">
                  <label className="text-xl text-gray-600">
                    Content <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    name="content"
                    className=" p-2 w-full border-2 border-gray-300"
                    onChange={(e) => setDescription(e.target.value)}
                    value={description}
                    rows="10"
                  ></textarea>
                </div>
                <div className="flex p-1">
                  <button
                    type="submit"
                    className="p-3 bg-blue-500 text-white rounded-full hover:bg-blue-400"
                    required
                  >
                    Add Blog
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddBlog;
